import React from 'react';
import I18n from 'utils/I18n';
import { ActionsCheckCircleOnXsmall } from '@strava/icons';

import styles from './TrialFeatures.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.trial';

const TrialFeatures = () => {
  const features = [
    {
      description: I18n.t(`${I18nPrefix}.feature_route`)
    },
    {
      description: I18n.t(`${I18nPrefix}.feature_analysis`)
    },
    {
      description: I18n.t(`${I18nPrefix}.feature_segment`)
    },
    {
      description: I18n.t(`${I18nPrefix}.feature_trail`),
      badge: I18n.t(`${I18nPrefix}.feature_trail_badge`)
    }
  ];

  return (
    <ul className={styles.trialFeatures}>
      {features.map((feature) => (
        <li className={styles.featureItem}>
          <div className={styles.featureItemIconContainer}>
            <ActionsCheckCircleOnXsmall />
          </div>
          <span>{feature.description}</span>
          {feature.badge && (
            <span className={styles.badge}>{feature.badge.toUpperCase()}</span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default TrialFeatures;
